<template>
  <div>
    <ysd-menu class="menu"></ysd-menu>
    <router-view />
    <ysd-footer class="footer"></ysd-footer>
    <ysd-board></ysd-board>
  </div>
</template>

<script>
import ysdMenu from "../components/menu/ysdMenu";
import ysdFooter from "../components/footer/ysdFooter";
import ysdBoard from "../components/board/board"
export default {
  // components:{ysdFooter,ysdBoard},
  components:{ysdMenu,ysdFooter,ysdBoard},
  name: "index",
}
</script>

<style scoped>

</style>